import fetch from '../utils/fetch'

//推荐商品列表
export const fetchRecommendList = (params) =>
  fetch(`/recommend/list`, {
    method: 'get',
    params,
  })

//商品列表
export const fetchGoodsList = (params) =>
  fetch(`/recommend/goodsList`, {
    method: 'get',
    params,
  })

//添加推荐商品
export const fetchAddGoods = (data) =>
  fetch(`/recommend`, {
    method: 'post',
    data,
  })

//删除推荐商品
export const fetchDeleteGoods = (data) =>
  fetch(`/recommend`, {
    method: 'delete',
    data,
  })

//推荐商品排序
export const fetchSortGoods = (data) =>
  fetch(`/recommend/sort`, {
    method: 'put',
    data,
  })

//专区商品
//推荐商品列表
export const fetchZhuanquRecommendList = (params) =>
  fetch(`/special/list`, {
    method: 'get',
    params,
  })

//添加推荐商品
export const fetchZhuanquAddGoods = (data) =>
  fetch(`/special`, {
    method: 'post',
    data,
  })

//删除推荐商品
export const fetchZhuanquDeleteGoods = (data) =>
  fetch(`/special`, {
    method: 'delete',
    data,
  })

//推荐商品排序
export const fetchZhuanquSortGoods = (data) =>
  fetch(`/special/sort`, {
    method: 'put',
    data,
  })
